var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('span',{staticClass:"nav-link disabled"},[(_vm.icon)?_c('div',{staticClass:"nav-icon disabled",class:{ full: !!this.$root.asideCompressed && !this.$root.asideHover }},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nav-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }